import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Billing frequency for invoice generation.
 */
export const schema = z.enum(['monthly', 'weekly', 'daily']);

export type BillingFrequency = z.infer<typeof schema>;

export const definition = define({
  key: 'billing_frequency',
  kind: DEFINITION_KINDS.SETTING,
  schema,
  writableAtLevels: [LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  label: 'Billing Frequency',
  description:
    'Determines how often we generate invoices for this client, which directly affects how often they are billed. This should be set to monthly, unless the client specifically requests otherwise.',
  category: CATEGORIES.BILLING.key,
  defaultValue: 'monthly',

  storage: {
    levels: {
      customer: {
        type: 'dedicated_column',
        table: 'customers',
        column: 'billing_frequency',
      },
    },
  },
});
